import { styleConstants } from '@styles/constants';

const getCirclePath = (x: number, y: number, r: number) =>
  ['M', x, y, 'm', -r, '0a', r, r, 0, 1, 0, r * 2, '0a', r, r, 0, 1, 0, -r * 2, 0].join(' ');

//Path taken from https://www.svgrepo.com/svg/46748/wifi - CC0 licence "No copyright"
const mastPath = [
  'M57.614,107.338c0-24.723,9.628-47.966,27.109-65.446c3.124-3.124,3.124-8.189,0-11.314c-3.124-3.122-8.188-3.123-11.314,0',
  'c-20.503,20.503-31.795,47.764-31.795,76.761c0,28.996,11.292,56.257,31.795,76.76c1.563,1.562,3.61,2.343,5.657,2.343',
  'c2.048,0,4.095-0.781,5.657-2.343c3.124-3.125,3.124-8.19,0-11.314C67.242,155.303,57.614,132.06,57.614,107.338z',
  'M17.683,107.338c0-35.389,13.781-68.658,38.806-93.682c3.124-3.124,3.124-8.189,0-11.314',
  'c-3.124-3.122-8.188-3.123-11.314,0C17.129,30.388,1.683,67.676,1.683,107.338s15.446,76.95,43.492,104.994',
  'c1.562,1.561,3.608,2.343,5.656,2.343c2.047,0,4.095-0.781,5.657-2.344c3.124-3.124,3.124-8.189-0.001-11.313',
  'C31.465,175.997,17.683,142.727,17.683,107.338z M111.193,57.047c-3.123-3.124-8.188-3.124-11.313-0.001C86.445,70.48,79.047,88.34,79.047,107.338',
  'c0,18.998,7.398,36.858,20.833,50.292c1.561,1.561,3.609,2.343,5.656,2.343c2.048,0,4.095-0.781,5.657-2.344',
  'c3.124-3.124,3.124-8.189-0.001-11.313c-10.411-10.411-16.145-24.253-16.145-38.978s5.734-28.566,16.145-38.978',
  'C114.317,65.237,114.317,60.171,111.193,57.047z M226.262,30.578c-3.125-3.123-8.189-3.123-11.314,0c-3.124,3.125-3.124,8.19,0,11.314',
  'c17.481,17.48,27.109,40.724,27.109,65.446c0,24.722-9.628,47.965-27.109,65.445c-3.124,3.124-3.124,8.189,0,11.314',
  'c1.563,1.562,3.609,2.343,5.657,2.343c2.047,0,4.095-0.781,5.657-2.343c20.503-20.503,31.795-47.764,31.795-76.76',
  'C258.057,78.341,246.765,51.081,226.262,30.578z	M254.497,2.342c-3.125-3.123-8.189-3.123-11.314,0c-3.124,3.125-3.124,8.191,0,11.314',
  'c25.024,25.023,38.806,58.293,38.806,93.682c0,35.389-13.781,68.658-38.805,93.68c-3.125,3.124-3.125,8.189-0.001,11.313',
  'c1.563,1.563,3.609,2.344,5.657,2.344c2.047,0,4.095-0.781,5.656-2.343c28.046-28.044,43.492-65.332,43.492-104.994',
  'S282.543,30.388,254.497,2.342z	M199.792,57.046c-3.124-3.124-8.19-3.123-11.314,0.001c-3.124,3.124-3.124,8.189,0.001,11.313',
  'c10.411,10.411,16.146,24.253,16.146,38.978s-5.734,28.566-16.146,38.978c-3.125,3.124-3.125,8.189-0.001,11.313',
  'c1.563,1.563,3.609,2.344,5.657,2.344c2.047,0,4.095-0.781,5.656-2.343c13.435-13.434,20.833-31.294,20.833-50.292',
  'C220.625,88.34,213.226,70.48,199.792,57.046z',
  'M167.137,90.37c-4.621-4.621-10.766-7.166-17.301-7.166c-6.534,0-12.679,2.545-17.303,7.167',
  'c-9.539,9.54-9.706,25.063-0.165,34.604c1.6,1.599,3.134,2.942,5.134,4.024v158.673c0,6.627,5.373,12,12,12s12-5.373,12-12V128.999',
  'c2-1.082,3.869-2.427,5.467-4.025C176.51,115.433,176.676,99.911,167.137,90.37z',
].join(' ');

const markerDefaults = {
  fillOpacity: 1,
  rotation: 0,
  scale: 1,
};

const getCircle = (color: string) => ({
  ...markerDefaults,
  path: getCirclePath(0, 0, 30),
  fillColor: color,
  strokeColor: styleConstants.colors.darkBlue,
  strokeWeight: 1,
  anchor: new google.maps.Point(0, 0),
});

const getMast = (color: string) => ({
  ...markerDefaults,
  path: mastPath,
  fillColor: color,
  strokeWeight: 0,
  scale: 0.5,
  anchor: new google.maps.Point(150, 280),
});

export const getStreetviewOptions = () => {
  return {
    addressControlOptions: {
      position: google.maps.ControlPosition.LEFT_TOP,
    },
  };
};

export const getGoogleMapMarkerForSiteOrMast = (
  map: google.maps.Map,
  latitude: number,
  longitude: number,
  /**
   * siteColor
   * - if provided -> marker for site
   * - if not provided -> marker for mast
   */
  siteColor?: string
) => {
  return {
    draggable: false,
    position: {
      lat: latitude,
      lng: longitude,
    },
    map: map,
    icon: siteColor ? getCircle(siteColor) : getMast(styleConstants.colors.black),
  };
};
